import r from "./index800.js";
function o(t) {
  return t === t && !r(t);
}
export {
  o as default
};
